import { render, staticRenderFns } from "./CriteriaInstructionsCell.vue?vue&type=template&id=51bffad2"
import script from "./CriteriaInstructionsCell.vue?vue&type=script&lang=js"
export * from "./CriteriaInstructionsCell.vue?vue&type=script&lang=js"
import style0 from "./CriteriaInstructionsCell.vue?vue&type=style&index=0&id=51bffad2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports